<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section">
      <div class="app-main">
        <header>
          <div class="data-header">
            <core-title-section
            [title]="'Artwork Statuses'"
            [description]="'Here you can manage your artwork status naming structure and the color coding for these.'"
            [breadcrumbs]="breadcrumbs"
            ></core-title-section>
            <div class="button-settings-add">
              <core-helpers-navigation-three-dots-menu
                [menu]="menu"
                (action)="onMenuClick($event)"
              ></core-helpers-navigation-three-dots-menu>
            </div>
          </div>
          <!-- <div class="instructions">
            <a (click)="showInstructions = !showInstructions" class="trigger" [ngClass]="{'opened' : showInstructions}"><em>How does this work?</em></a>
            <ol *ngIf="showInstructions">
              <li >Add a <strong>NEW ARTWORK STATUS NAME</strong> by clicking the button.</li>
              <li >Once it appears in the list, <strong>GIVE IT A COLOR</strong> so that they are easier to recognize.</li>
              <li ><strong>DEACTIVATE</strong> a status you no longer need. <strong>ACTIVATE</strong> it back if you need to use it again.</li>
            </ol>
          </div>
          -->
        </header>
        <div class="version-status-add" [hidden]="!showForm">
          <settings-version-status-add-form (cancel)="showForm = false" (submit)="onSaved($event)"></settings-version-status-add-form>
        </div>
        <div class="box_default box_white version-status-list">
          <div class="" *ngIf="status == STATUS_DONE">
            <h3><span>CURRENT ARTWORK STATUSES</span></h3>
            <ul class="version-status-ul" >
              <core-helpers-lists-one-action-color-list-item
              *ngFor="let status of versionStatus | sortByActive "
              [colorOptions] = "colorOptions"
              [color]="status.color"
              [title]="status.name"
              [actionText]="status.active? 'Deactivate' : 'Activate'"
              (actionClick)="status.active? deactivate(status) : activate(status)"
              (colorChange)="onColorChange($event,status)"
              [type]="status.active? 'disabled': 'inactive'"
              ></core-helpers-lists-one-action-color-list-item>
            </ul>
          </div>
          <div class="loader">
            <div class="dimmed" [hidden]="status == STATUS_DONE">
              <div class="dimmed_title"></div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
              <div class="dimmed_flex">
                <div class="dimmed_box"></div>
                <div class="dimmed_subtitle"></div>
              </div>
            </div>
            <!-- <core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading> -->
          </div>

        </div>
      </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
